import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button, Col, Row,
} from 'react-bootstrap';
import Table from 'components/Table';
import TextField from 'components/Form/TextField';
import { CellProps } from 'react-table';
import { DTable } from 'types/table';
import { IoIosAddCircleOutline } from 'react-icons/io';
import _ from 'lodash';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import useModal from 'hooks/useModal';
import CreateDocRequestTemplateModal from 'components/Modal/CreateDocRequestTemplateModal';
import { DocRequestTemplateCategoryType, DocRequestTemplateProps } from 'types/DocRequestTemplate';
import DeleteDocRequestTemplateModal from 'components/Modal/DeleteDocRequestTemplateModal';

function DocsRequestTemplateView( {
  data, fetchData, isLoading, reloadData, category,
}:{
  reloadData: ()=>void;
  isLoading?:boolean;
  data: DTable;
  category: DocRequestTemplateCategoryType,
  fetchData: ( params:any, pageSize:number )=>void ; } ) {
  const { t } = useTranslation();
  const [criteria, setCriteria] = useState( '' );

  const {
    showModal: showEditModal,
    closeModal: closeEditModal,
    openModal: openEditModal,
    selectedItem: selectedEditItem,
  } = useModal<DocRequestTemplateProps>();

  const {
    showModal: showDeleteModal,
    closeModal: closeDeleteModal,
    openModal: openDeleteModal,
    selectedItem: selectedDeleteItem,
  } = useModal<DocRequestTemplateProps>();

  const debounceSearch = useCallback( _.debounce( ( fn ) => fn(), 500 ), [] );

  return (
    <>
      <h3 className="mt-3">{t( `admin.doctemplate.category.${category}` )}</h3>
      <hr />
      <Table
        columns={[
          {
            Header: t( 'admin.doctemplate.id' ),
            accessor: 'plantillaId',
            customWidth: 150,
          },
          {
            Header: t( 'admin.doctemplate.name' ),
            accessor: 'nombre',
          },
          {
            Header: t( 'admin.doctemplate.description' ),
            accessor: 'descripcion',
          },
          {
            Header: t( 'admin.doctemplate.required' ),
            accessor: 'requerido',
            customWidth: 150,
          },
          {
            Header: t( 'admin.doctemplate.status' ),
            accessor: 'estado',
            customWidth: 150,
          },
          {
            Header: t( 'admin.common.actions' ),
            accessor: 'plantillaId',
            id: 'actions',
            disableSortBy: true,
            customWidth: 120,
            Cell: ( { cell }:CellProps<any> ) => (
              <>
                <Button
                  className="p-0 me-1"
                  variant="link"
                  onClick={() => {
                    openEditModal( cell.row.original );
                  }}
                >
                  <AiOutlineEdit />
                </Button>
                <Button
                  className="p-0"
                  variant="link"
                  onClick={() => {
                    openDeleteModal( cell.row.original );
                  }}
                >
                  <AiOutlineDelete />
                </Button>
              </>
            ),
          },
        ]}
        isLoading={isLoading}
        data={data.data}
        total={data.totalItems}
        pageCount={data.pageCount}
        fetchData={fetchData}
        header={( filters, setFilters ) => (
          <Row className="align-items-center">
            <Col lg={9} sm={8} xs={6}>
              <Button
                size="sm"
                className="pt-2 pb-2 ps-4 pe-4 text--normal btn--rounded d-flex align-items-center"
                onClick={() => openEditModal()}
              >
                <IoIosAddCircleOutline size={24} className="me-2" />
                {t( 'admin.doctemplate.create' )}
              </Button>
            </Col>
            <Col lg={3} sm={4} xs={6}>
              <TextField
                value={criteria}
                showErrors={false}
                placeholder="search"
                appendIcon="icon-search text-primary"
                onChange={( value ) => {
                  setCriteria( value );
                  debounceSearch( () => setFilters( ['nombre'], value ) );
                }}
                classNames={{ formGroup: 'input-filters' }}
              />
            </Col>
          </Row>
        )}
      />

      {showEditModal && (
      <CreateDocRequestTemplateModal
        data={selectedEditItem}
        category={category}
        onClose={closeEditModal}
        reloadData={reloadData}
      />
      )}

      {showDeleteModal && (
      <DeleteDocRequestTemplateModal
        dataId={selectedDeleteItem?.plantillaId as number}
        onClose={closeDeleteModal}
        reloadData={reloadData}
      />
      )}
    </>
  );
}

export default DocsRequestTemplateView;
